import { CheckCircle2, XCircle, Clock3, Banknote } from "lucide-react";

const MAP = {
  confermato: { label: "Confermato", cls: "bg-emerald-50 text-emerald-700", icon: CheckCircle2 },
  disdetto: { label: "Disdetto", cls: "bg-rose-50 text-rose-700", icon: XCircle },
  in_attesa: { label: "In attesa", cls: "bg-slate-100 text-slate-500", icon: Clock3 },
};

export const statusTone = (s) => (s === "confermato" ? "green" : s === "disdetto" ? "rose" : "teal");

export const PaymentBadge = ({ appt, testid }) => (appt.payment_reported ? (
  <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-700" data-testid={testid}>
    <Banknote className="h-3 w-3" /> Pagamento segnalato
  </span>
) : null);

export const AppointmentStatus = ({ status, testid }) => {
  const m = MAP[status] || MAP.in_attesa;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${m.cls}`} data-testid={testid}>
      <m.icon className="h-3 w-3" /> {m.label}
    </span>
  );
};
